/* PLUSMAKER notification chime — a minimal neutral two-tone chime synthesized
   with the Web Audio API. No audio asset file, no copyrighted material.
   Rules honoured here: sound only after a user interaction, never on page load,
   respects the member's ON/OFF preference (device-level localStorage), and any
   browser audio block is swallowed silently — notifications still show. */

let ctx = null;
let userInteracted = false;

if (typeof window !== "undefined") {
  const mark = () => {
    userInteracted = true;
  };
  window.addEventListener("pointerdown", mark);
  window.addEventListener("keydown", mark);
}

const PREF_KEY = "pm_notification_sound";

export const hasUserInteracted = () => userInteracted;

export const getSoundEnabled = () => {
  try {
    return localStorage.getItem(PREF_KEY) !== "off";
  } catch {
    return true;
  }
};

export const setSoundEnabled = (on) => {
  try {
    localStorage.setItem(PREF_KEY, on ? "on" : "off");
  } catch {}
};

export function playNotificationChime() {
  try {
    if (!userInteracted || !getSoundEnabled()) return;
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = ctx || new AC();
    if (ctx.state === "suspended") {
      ctx.resume().catch(() => {});
    }
    const t = ctx.currentTime + 0.02;
    [
      [880, 0],
      [1174.66, 0.12],
    ].forEach(([freq, delay]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t + delay);
      gain.gain.exponentialRampToValueAtTime(0.055, t + delay + 0.03);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + delay + 0.5);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t + delay);
      osc.stop(t + delay + 0.55);
    });
  } catch {
    /* audio blocked by the browser — the notification itself is unaffected */
  }
}
